import { ProTable } from '@ant-design/pro-components'
import { PatientMedicalSupplyAccessEditDrawer } from '@app/icare/entities/patient/edits/PatientMedicalSupplyAccessEditDrawer'
import { patientMedicalSupplyAccessQueries } from '@app/icare/entities/patient/queries/patientMedicalSupplyAccessQueries'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { MedicalSupplyAccessTypeEnum } from '@app/icare/entities/patient/schema/PatientMedicalSupplyAccess'
import { sortByActiveRange } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button } from 'antd'
import { FaPencil } from 'react-icons/fa6'

export const Route = createFileRoute('/_app/patienten/$id/_edit/anamnese/zugang')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientMedicalSupplyAccessQueries.forList(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()
  const { data: accesses = [] } = useSuspenseQuery(patientMedicalSupplyAccessQueries.forList(patientId))

  return (
    <ProTable
      search={false}
      options={false}
      rowKey="id"
      size="small"
      dataSource={accesses}
      locale={{ emptyText: t`Keine Zugänge vorhanden` }}
      columns={[
        {
          title: t`Zugang`,
          dataIndex: 'access',
          render: (_, r) => MedicalSupplyAccessTypeEnum.$.getLabel(r.access),
        },
        {
          title: t`Gültig von`,
          dataIndex: 'activeFrom',
          valueType: 'date',
          defaultSortOrder: 'descend',
          sorter: sortByActiveRange,
        },
        {
          title: t`Gültig bis`,
          dataIndex: 'activeTo',
          valueType: 'date',
        },
        {
          valueType: 'option',
          render: (_t, r) => [
            <Button
              key="edit"
              type="text"
              size="small"
              icon={<FaPencil />}
              onClick={() => PatientMedicalSupplyAccessEditDrawer.show({ patientId, relationId: r.id })}
            />,
          ],
        },
      ]}
    />
  )
}
